import type { RJSFValidationError, ValidatorType } from '@rjsf/utils';
import MarkdownIt from 'markdown-it';

// Initialize Markdown renderer
export const md = new MarkdownIt({
  breaks: true,
  linkify: true,
});

// Create a custom validator that doesn't use AJV to avoid CSP issues
export const validator: ValidatorType = {
  validateFormData: () => ({
    errors: [] as RJSFValidationError[],
    errorSchema: {},
  }),
  isValid: () => true,
  rawValidation: () => ({ errors: [], validationError: undefined }),
  toErrorList: () => [],
};
